/**
 * NewProjectWizard Types
 * 위저드 관련 타입 정의
 */

import type { SystemScope, PartitionFormData } from '@/types/project';
import { modelSlotLabel } from '@/domain/modelSlot';

// 위저드 스텝 정의 (Step 4: MARS 파티션 존재 시 동적 추가)
export type WizardStep = 1 | 2 | 3 | 4;

// 위저드 스텝 정보
export interface StepInfo {
  step: WizardStep;
  label: string;
  description: string;
}

// 동적 위저드 스텝 생성 (GUI MARS 파티션 유무에 따라 Step 4 추가)
export const getWizardSteps = (hasMarsPartition: boolean): StepInfo[] => {
  const steps: StepInfo[] = [
    { step: 1, label: 'Step 1', description: '기본 정보' },
    { step: 2, label: 'Step 2', description: 'Scope 선택' },
    { step: 3, label: 'Step 3', description: 'Partition 설정' },
  ];

  if (hasMarsPartition) {
    steps.push({ step: 4, label: 'Step 4', description: 'MARS 설정' });
  }

  return steps;
};

// 하위 호환용 기본 스텝 (Step 4 없음)
export const WIZARD_STEPS: StepInfo[] = getWizardSteps(false);

// 위저드 폼 데이터
export interface WizardFormData {
  // Step 1: 기본 정보
  title: string;
  description: string;
  // Step 2: Project Scope
  scope: SystemScope[];
  // Step 3: Partitions
  partitions: PartitionFormData[];
}

/** 파티션을 가리키는 이름 — 입력한 이름, 비었으면 차례(카드 머리와 검증 문구가 같은 이름으로 가리킨다) */
export const partitionLabel = (partition: Pick<PartitionFormData, 'name'>, index: number): string =>
  partition.name.trim() || `${modelSlotLabel(index + 1)}`;

// 초기 폼 데이터
export const INITIAL_WIZARD_DATA: WizardFormData = {
  title: '',
  description: '',
  scope: [],
  partitions: [],
};

// Partition 색상 — reuses the categorical palette; bg derived via color-mix for theme-correct tint
const mkPartition = (tok: string) => ({
  bg: `color-mix(in oklch, var(${tok}) 18%, var(--bg-panel))`,
  color: `var(${tok})`,
  border: `var(${tok})`,
});
export const PARTITION_COLORS = [
  mkPartition('--cat-2'), // blue
  mkPartition('--cat-3'), // green
  mkPartition('--cat-5'), // orange
  mkPartition('--cat-4'), // yellow / purple-ish
  mkPartition('--cat-7'), // rose
  mkPartition('--cat-6'), // vermillion
  mkPartition('--cat-1'), // base
  mkPartition('--cat-8'), // neutral
];

